import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '@equine-ui-nx/account';
import { LoginService } from '../../data-access/login.service';
import {  FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { EmailComponent, EqValidator, PasswordComponent, TextInputComponent } from '@equine-ui-nx/ui';
import { MatButton } from '@angular/material/button';
import { LoginRequest } from '../../interfaces/login.interface';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';

import {MatCardModule} from '@angular/material/card';
import {MatTableModule} from '@angular/material/table';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';

interface Transaction {
  item: string;
  Price: number;
  Quantity: number;
  cost: number;
}
interface Transaction1 {
  item: string;
  cost: number;
}

@Component({
  selector: 'login-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule,
    EmailComponent,
    PasswordComponent,
    MatButton,
    MatTabsModule,
    TextInputComponent,
    MatIcon,
    MatCardModule,
    MatTableModule,
    MatCheckboxModule,
    MatRadioModule
  ],
  templateUrl: './login-form.component.html',
  styleUrl: './login-form.component.scss',
})
export class LoginFormComponent {

  displayedColumns: string[] = ['item', 'Price', 'Quantity', 'cost'];
  
  transactions: Transaction[] = [
    {item: 'Youth Rider Membership', Price: 70, Quantity: 1, cost: 70},
    {item: 'JEM Membership', Price: 35, Quantity: 1, cost: 35},
    {item: 'Coach Membership', Price: 60, Quantity: 1, cost: 60},
  ];

  getTotalCost() {
    return this.transactions.map(t => t.cost).reduce((acc, value) => acc + value, 0);
  }

  displayedColumns1: string[] = ['item', 'cost'];
  transactions1: Transaction1[] = [
    {item: 'Youth Rider Membership', cost: 70},
    {item: 'JEM Membership', cost: 35},
    {item: 'Coach Membership', cost: 60},
  ];
    /** Gets the total cost of all transactions. */
    getTotalCost1() {
      return this.transactions1.map(t => t.cost).reduce((acc, value) => acc + value, 0);
    }

  
  checked = false;
  indeterminate = false;
  labelPosition: 'before' | 'after' = 'after';
  disabled = false;


  public loginForm = new FormGroup({});
  public emailLoginForm = new FormGroup({});
  public usernameLoginForm = new FormGroup({});
  @Output('login') loginEvent = new EventEmitter<LoginRequest>();
  @Input() appName: string = "";
  loginError: boolean = false;
  loginErrorMessage: string = '';
  passwordResetUrl = 'account/resetPassword';
  signUpUrl = 'account/signup';
  logoUrl = ``
  backgroundImageId = ``
  headerLabel = ``
  constructor(
    public authService: AuthService,
    public loginService: LoginService,
    public router: Router
  ) {
    authService.cleanLocalStorage();
   }
  ngOnInit(): void {
    this.loginService.resetFormEvent.subscribe(() => {
      this.resetForm();
    });
    if(this.appName == "arenaEqApp"){
      this.backgroundImageId = 'intro-arena'
      this.logoUrl = `assets/images/arenaEq-logo.png`
      this.headerLabel = 'ACCOUNT LOGIN'
    }else{
      this.logoUrl = `../../../assets/images/access-logo-full.png`
      this.backgroundImageId = 'intro-iea'
      this.headerLabel = 'MEMBER LOGIN'
    }
  }
  requiredValidator = {
    validators: Validators.required,
    message: 'This field is required',
    error: 'required',
  };
  emailValidator: EqValidator[] = [
    this.requiredValidator,
    {
      validators: Validators.email,
      message: 'Please enter valid email.',
      error: 'email'
    },
    {
      validators: Validators.pattern(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/),
      message: 'Please enter valid email.',
      error: 'pattern',
    },
  ]
  passWordValidator: EqValidator[] = [
    {
      validators: Validators.required,
      message: 'This field is required',
      error: 'required',
    },
  ]

  userNameValidator: EqValidator[] = [
    this.requiredValidator,
    {
      validators: Validators.pattern(/^[a-zA-Z0-9]+$/),
      error: 'pattern',
      message:
        'Username should not be an email addresses',
    }
  ];

  loginWithEmail (type: string) {
    if (this.emailLoginForm.valid) {
      const loginData: LoginRequest = {
        userName: this.emailLoginForm.get('email')?.value,
        passWord: this.emailLoginForm.get('passWord')?.value,
        type: type
      };
      this.loginEvent.emit(loginData);
    }
  }

  loginWithUserName (type: string) {
    if (this.usernameLoginForm.valid) {
      const loginData: LoginRequest = {
        userName: this.usernameLoginForm.get('username')?.value,
        passWord: this.usernameLoginForm.get('passWord')?.value,
        type: type
      };
      this.loginEvent.emit(loginData);
    }
  }

  goToPage(url: string, target: string = '_self'){
    if(target == '_self'){
      this.router.navigateByUrl(url);
    }else{
      window.open(url, target);
    }
  }

  resetForm() {
    this.loginForm.reset();
    this.loginForm.markAsPristine();
  }

}
